(function () {
  if (window.__introOfferCtaBound) return;
  window.__introOfferCtaBound = true;

  var VARIANT_ID = 45130018128064;
  var SELLING_PLAN_ID = 2784657600;
  var DISCOUNT_CODE = 'INTRO50';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.intro-offer-cta');
    if (!btn) return;
    e.preventDefault();

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: VARIANT_ID, quantity: 1, selling_plan: SELLING_PLAN_ID }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not add to cart');
        window.location.href = '/discount/' + DISCOUNT_CODE + '?redirect=/cart';
      })
      .catch(function (err) {
        console.error('[Intro Offer CTA]', err);
        btn.disabled = false;
        btn.textContent = original;
        window.location.href = '/discount/' + DISCOUNT_CODE + '?redirect=/products/6-monthly-mobile-app-subscription';
      });
  });
})();
